import ToggleGroup from './ToggleGroup';

export default function ImageAlignProperty() {
  const horizontalOptions = [
    { value: 'left', icon: 'AlignLeftIcon', tooltip: 'Left' },
    { value: 'center', icon: 'AlignCenterIcon', tooltip: 'Center' },
    { value: 'right', icon: 'AlignRightIcon', tooltip: 'Right' },
  ]

  const verticalOptions = [
    { value: 'top', icon: 'ArrowUpToLine', tooltip: 'Top' },
    { value: 'middle', icon: 'FlipVertical2', tooltip: 'Middle' },
    { value: 'bottom', icon: 'ArrowDownToLine', tooltip: 'Bottom' },
  ]

  return <>
    <div className='flex flex-col gap-1'>
      <ToggleGroup
        name='imageAlign.horizontal'
        options={horizontalOptions}
        type='single'
      />

      <ToggleGroup
        name='imageAlign.vertical'
        options={verticalOptions}
        type='single'
      />
    </div>
  </>
}
